<template>
  <modal
    v-if="quickEdit"
    :title="$t('OrderCurrent.actions.quickEdit')"
    @close-request="clearSelected()"
    closable
    >
    <table-element
        :isShowFilter="false"
        :title="$t('OrderCurrent.modal.selected_orders')"
        :fields="fieldsObjEDI"
        :arrOfElement="selectedFull"
        :sortSpacing="0"
        class="card mx-2 mt-4"
    >
        <template #header-actions>
            <p class="m-2 mb-0 mt-2">{{$t('OrderCurrent.count')}} {{selectedFull.length}}</p>
        </template>

        <template #body-content-desktop="content">
        <!-- List of orders -->
        <tr v-for="(order, index) in content.results"
        class="table-element_hover text-center"
        :key="index"
        :class="{
            'drop': order.status === 'Drop',
            'cancel': order.status === 'Cancel',
            'waiting': order.status === 'Attente',
            'pick': order.status === 'Pick',
            'transit': order.status === 'Transit',
            'dispatch': order.status === 'Dispatch',
            'reject': order.status === 'Reject',
            'inspection': order.status === 'Inspection',
            'transfered': order.status === 'Transférée'
            }">
            <td>
            {{order.orderNumber}}
            </td>
            <td>
            <regular-input
                :value="order.source"
                @input="order.source = $event"
                type="text" :placeholder="$t('OrderCurrent.source')"/>
            </td>
            <td>
            <regular-input
                :value="order.numRef"
                @input="order.numRef = $event"
                type="text" :placeholder="$t('OrderInfo.modal.reference')"/>
            </td>
            <td>
            <regular-input
                :value="order.note"
                @input="order.note = $event; feedbackMessage = ''"
                type="text" :placeholder="$t('CreateNote.reason_for_edit')"/>
            </td>
            <td>
            <fee-selector
                :showTitle="false"
                :initialFees="order.fees"
                @fees-updated="(fees) => order.fees = fees"
            />
            </td>
            <td>
            <regular-input
                :value="order.price"
                @input="order.price = $event"
                type="number" :placeholder="$t('OrderInfo.modal.price')"/>
            </td>
            <td>
            <regular-input
                :value="order.fuelCharge"
                @input="onFuelChargeInput(order, $event)"
                type="number" :placeholder="$t('OrderCurrent.modal.fuel_charge_percent_placeholder')"/>
            <regular-checkbox
                :checked="isFuelChargeIncluded(order)"
                @change="toggleFuelChargeIncluded(order, $event)"
                :label="$t('OrderCurrent.modal.fuel_charge_included')"
                class="mt-2"/>
            </td>
            <td>
            <regular-input
                :value="order.odooComment"
                @input="order.odooComment = $event"
                type="text" :placeholder="$t('OrderPending.orderTab.odooBillingComment')"/>
            </td>
        </tr>
        </template>

        <template #body-content-mobile="content">
        <!-- List of orders -->
        <div
            v-for="(order) in content.results"
            class="card my-3 mx-2"
            :key="order.orderNumber"
            :class="{
            'drop': order.status === 'Drop',
            'cancel': order.status === 'Cancel',
            'waiting': order.status === 'Attente',
            'pick': order.status === 'Pick',
            'transit': order.status === 'Transit',
            'dispatch': order.status === 'Dispatch',
            'reject': order.status === 'Reject',
            'inspection': order.status === 'Inspection'
        }">
            <div class="card-header m-1">
            {{order.orderNumber}}
            </div>
            <div class="m-1">
            <div>
                <span>
                {{$t('OrderCurrent.source')}}
                <regular-input
                    min="0"
                    :value="order.source"
                    @input="order.source = $event"
                    type="text" :placeholder="$t('OrderCurrent.source')"/>
                </span>
            </div>
            <div>
                <span>
                {{$t('OrderInfo.modal.reference')}}
                <regular-input
                    min="0"
                    :value="order.numRef"
                    @input="order.numRef = $event"
                    type="text" :placeholder="$t('OrderInfo.modal.reference')"/>
                </span>
            </div>
            <div>
                <fee-selector
                    :showTitle="false"
                    :initialFees="order.fees"
                    @fees-updated="(fees) => order.fees = fees"
                />
            </div>
            <div>
                <span>
                {{$t('OrderInfo.modal.price')}}
                <regular-input
                    :value="order.price"
                    @input="order.price = $event"
                    type="number" :placeholder="$t('OrderInfo.modal.price')"/>
                </span>
            </div>
            <div>
                <span>
                {{$t('OrderCurrent.modal.fuel_charge_percent')}}
                <regular-input
                    :value="order.fuelCharge"
                    @input="onFuelChargeInput(order, $event)"
                    type="number" :placeholder="$t('OrderCurrent.modal.fuel_charge_percent_placeholder')"/>
                <regular-checkbox
                    :checked="isFuelChargeIncluded(order)"
                    @change="toggleFuelChargeIncluded(order, $event)"
                    :label="$t('OrderCurrent.modal.fuel_charge_included')"
                    class="mt-2"/>
                </span>
            </div>
            <div>
                <span>
                {{$t('OrderPending.orderTab.odooComment')}}
                <regular-input
                    :value="order.odooComment"
                    @input="order.odooComment = $event"
                    type="text" :placeholder="$t('OrderPending.orderTab.odooBillingComment')"/>
                </span>
            </div>
            </div>
        </div>
        </template>

        <template #post-body-content>
        <div class="mt-2">
            <p class="mx-2 red-text text-right">{{feedbackMessage}}</p>
            <button @click="onQuickEditAction()" class="float-right btn btn-kne-orange m-2">{{$t('OrderCurrent.modal.confirm')}}</button>
            <button @click="clearSelected()" class="float-right btn btn-danger m-2">{{$t('OrderCurrent.modal.cancel')}}</button>
        </div>
        </template>

    </table-element>
  </modal>
</template>

<script>
import Modal from '../../interface-components/Modal.vue'
import TableElement from '../Table-component/Table-Element.vue'
import regularInput from '../../basic-components/regularInput.vue'
import feeSelector from '../../basic-components/feeSelector.vue'
import regularCheckbox from '../../basic-components/regularCheckbox.vue'
import { db } from '../../../../firebase'
import { publishOrderSyncRequest } from '../../../../odoo-sync-requests/order'

export default {
    name: 'QuickEdit',
    components: {
        Modal,
        TableElement,
        feeSelector,
        regularInput,
        regularCheckbox
    },

    data () {
        return {
            selectedFull: [],
            originalPriceByOrder: {},
            originalFuelChargeByOrder: {},
            originalIncludedFuelChargeByOrder: {},
            feedbackMessage: '',
            fieldsObjEDI: [
                {
                    text: this.$t('OrderCurrent.order'),
                    type: 'orderNumber',
                    value: ''
                },
                {
                    text: this.$t('OrderCurrent.source'),
                    type: 'source',
                    value: ''
                },
                {
                    text: this.$t('OrderCurrent.reference'),
                    type: 'numRef',
                    value: ''
                },
                {
                    text: this.$t('OrderCurrent.reason'),
                    type: 'note',
                    value: ''
                },
                {
                    text: this.$t('OrderPending.orderTab.addOdooFee'),
                    type: '',
                    value: ''
                },
                {
                    text: this.$t('OrderInfo.modal.price'),
                    type: 'price',
                    value: ''
                },
                {
                    text: this.$t('OrderCurrent.modal.fuel_charge_percent'),
                    type: 'fuelCharge',
                    value: ''
                },
                {
                    text: this.$t('OrderPending.orderTab.odooComment'),
                    type: 'odooComment',
                    value: ''
                }
            ]
        }
    },

    props: {
        quickEdit: Boolean,
        arrOfOrder: {
            type: Array,
            required: true
        },
        user: {
            type: Object,
            required: true
        }
    },

    methods: {
        normalizePrice (value) {
            const parsedPrice = Number(value)
            if (isNaN(parsedPrice)) return 0
            return Number(parsedPrice.toFixed(2))
        },
        normalizeFuelCharge (value) {
            const parsedFuelCharge = Number(value)
            if (isNaN(parsedFuelCharge)) return 0
            return Number(parsedFuelCharge.toFixed(2))
        },
        formatPriceForNote (value) {
            return `${this.normalizePrice(value).toFixed(2)}$`
        },
        formatFuelChargeForNote (value) {
            return `${this.normalizeFuelCharge(value).toFixed(2)}%`
        },
        buildPriceChangeNoteText (previousPrice, nextPrice) {
            return `PRICE MODIFIED: ${this.formatPriceForNote(previousPrice)} -> ${this.formatPriceForNote(nextPrice)}`
        },
        describeFuelChargeForNote (fuelCharge, includedFuelCharge) {
            const fuelChargeText = this.formatFuelChargeForNote(fuelCharge)
            return includedFuelCharge ? `Included (${fuelChargeText})` : fuelChargeText
        },
        buildFuelChargeChangeNoteText (previousFuelCharge, nextFuelCharge, previousIncludedFuelCharge, nextIncludedFuelCharge) {
            return `FUEL CHARGE MODIFIED: ${this.describeFuelChargeForNote(previousFuelCharge, previousIncludedFuelCharge)} -> ${this.describeFuelChargeForNote(nextFuelCharge, nextIncludedFuelCharge)}`
        },
        hasFuelChargeValue (value) {
            return value !== undefined && value !== null && value !== ''
        },
        getDefaultFuelCharge () {
            return this.hasFuelChargeValue(this.$store.state.userInfo.fuelCharge)
                ? this.$store.state.userInfo.fuelCharge
                : 0
        },
        isFuelChargeIncluded (order) {
            return order.includedFuelCharge === true || order.applyFuelCharge === false
        },
        onFuelChargeInput (order, value) {
            this.$set(order, 'fuelCharge', value)
            if (value !== '') {
                this.$set(order, 'includedFuelCharge', false)
                this.$set(order, 'applyFuelCharge', true)
            }
        },
        toggleFuelChargeIncluded (order, checked) {
            this.$set(order, 'includedFuelCharge', checked)
            this.$set(order, 'applyFuelCharge', !checked)
        },
        prepareQuickEditOrder (order) {
            if (!order) return

            const orderId = order.orderNumber
            if (!Array.isArray(order.fees)) this.$set(order, 'fees', [])
            if (!this.hasFuelChargeValue(order.fuelCharge)) this.$set(order, 'fuelCharge', this.getDefaultFuelCharge())
            if (order.includedFuelCharge === undefined) this.$set(order, 'includedFuelCharge', order.applyFuelCharge === false)
            if (order.applyFuelCharge === undefined || order.applyFuelCharge === '') this.$set(order, 'applyFuelCharge', !order.includedFuelCharge)

            if (orderId && !(orderId in this.originalPriceByOrder)) {
                this.$set(this.originalPriceByOrder, orderId, this.normalizePrice(order.price))
            }
            if (orderId && !(orderId in this.originalFuelChargeByOrder)) {
                this.$set(this.originalFuelChargeByOrder, orderId, this.normalizeFuelCharge(order.fuelCharge))
            }
            if (orderId && !(orderId in this.originalIncludedFuelChargeByOrder)) {
                this.$set(this.originalIncludedFuelChargeByOrder, orderId, this.isFuelChargeIncluded(order))
            }
        },
        onQuickEditAction () {
            console.log('here here!')
            this.selectedFull.forEach((element, index) => {
                const orderId = element.orderNumber
                const noteObj = {
                    date: Date.now(),
                    text: element.note,
                    name: this.setNoteName(this.user)
                }
                const notesToSave = []
                const previousPrice = this.normalizePrice(this.originalPriceByOrder[orderId])
                const currentPrice = this.normalizePrice(element.price)
                const previousFuelCharge = this.normalizeFuelCharge(this.originalFuelChargeByOrder[orderId])
                const currentFuelCharge = this.normalizeFuelCharge(element.fuelCharge)
                const previousIncludedFuelCharge = this.originalIncludedFuelChargeByOrder[orderId] === true
                const currentIncludedFuelCharge = this.isFuelChargeIncluded(element)

                if (noteObj.text) notesToSave.push(noteObj)
                if (currentPrice !== previousPrice) {
                    notesToSave.push({
                        date: Date.now(),
                        text: this.buildPriceChangeNoteText(previousPrice, currentPrice),
                        name: this.setNoteName(this.user)
                    })
                }
                if (currentFuelCharge !== previousFuelCharge || currentIncludedFuelCharge !== previousIncludedFuelCharge) {
                    notesToSave.push({
                        date: Date.now(),
                        text: this.buildFuelChargeChangeNoteText(previousFuelCharge, currentFuelCharge, previousIncludedFuelCharge, currentIncludedFuelCharge),
                        name: this.setNoteName(this.user)
                    })
                }

                this.saveOrdersFirebase(orderId, element, notesToSave)

                if (Array.isArray(element.fees) && element.fees.length > 0) {
                    delete element['.key']
                    db.ref('database/transporter/' + this.companyUID + '/deliveries/' + element.orderNumber).update(element)
                }
            })

            this.clearSelected()
        },
        setNoteName (user) {
            const isFirstNameValid = (typeof user.firstName !== 'undefined' && user.firstName !== '')
            const isLastNameValid = (typeof user.lastName !== 'undefined' && user.lastName !== '')

            if (!isFirstNameValid || !isLastNameValid) return this.$store.state.userInfo.name
            else return `${user.firstName} ${user.lastName}`
        },
        saveOrdersFirebase (orderId, element, notesToSave) {
            if (Array.isArray(notesToSave) && notesToSave.length > 0) {
                notesToSave.forEach((noteObj) => {
                    db.ref('database/transporter/' + this.companyUID + '/deliveries/' + orderId + '/notes/').push(noteObj)
                })
            }

            const updateData = {
                'source': element.source || '',
                'numRef': element.numRef || '',
                'price': this.normalizePrice(element.price),
                'fuelCharge': this.normalizeFuelCharge(element.fuelCharge),
                'includedFuelCharge': this.isFuelChargeIncluded(element),
                'applyFuelCharge': !this.isFuelChargeIncluded(element),
                'odooComment': element.odooComment || ''
            }
            db.ref('database').child('transporter').child(this.companyUID).child('deliveries').child(orderId).update(updateData).then(() => {
                publishOrderSyncRequest(orderId, this.companyUID)
                // ======================== ADD FAST BILLING LOG =======================
                this.$store.dispatch('newLog', {'UID': this.uid, 'action': 'QUICK_EDIT', 'orderID': orderId, 'date': Date.now()})
            })
        },
        clearSelected () {
            this.$emit('closeQuickModal')
        },
        checkIsUndefined (data) {
            return (typeof data === 'undefined')
        },
        clearfeedbackMessage () {
            this.feedbackMessage = ''
        }
    },

    computed: {
      companyUID () {
        return this.$store.state.authorization.company
      },
      uid () {
        return this.$store.state.user.uid
      },
      userInfo () {
        return this.$store.state.userInfo
      }
    },

    watch: {
        arrOfOrder: {
            immediate: true,
            deep: true,
            handler (val) {
                this.selectedFull = Array.isArray(val) ? val : []
                if (!this.selectedFull.length) {
                    this.originalPriceByOrder = {}
                    this.originalFuelChargeByOrder = {}
                    this.originalIncludedFuelChargeByOrder = {}
                    return
                }
                this.selectedFull.forEach((order) => {
                    this.prepareQuickEditOrder(order)
                })
            }
        }
    }
}
</script>
